// extracted by mini-css-extract-plugin
export default {"icon":"ThirdPartyContactSourceIcon_icon"};